import React from 'react';

import {Dialogue, Button, Anchor, Text} from '@albert-io/atomic';

interface Props {
  className: string;
  handleClose: () => void;
}

const LaunchSessionCookieNotFound = ({className, handleClose}: Props) => (
  <Dialogue
    hideCloseBtn
    className={className}
    size='m'
    title='We could not access your roster information.'
  >
    <Dialogue.Body>
      <div className='u-display_flex u-flex-direction_column'>
        <Text className='u-mar-b_3'>We could not detect any class rosters from an LMS.</Text>

        <Anchor href='https://help.albert.io/en/articles/5350870-how-do-i-use-canvas-on-albert-as-a-teacher#h_3303c5848e'>
          Learn how to import classes from your LMS.
        </Anchor>
      </div>
    </Dialogue.Body>
    <Dialogue.BtnGroup>
      <Button onClick={() => handleClose()}>Dismiss</Button>
    </Dialogue.BtnGroup>
  </Dialogue>
);

export default LaunchSessionCookieNotFound;
